var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isLoggedIn
    ? _c(
        "div",
        [
          _c("i-q-view", { ref: "thisView", on: { click: _vm.onClick } }),
          _c("userDataChange", { ref: "thisUserDataChange" }),
          _c("userEmailChangeSimple", { ref: "thisUserEmailChangeSimple" }),
          _c("userPhoneChange", { ref: "thisUserPhoneChange" }),
          _c("userPasswordChange", {
            ref: "thisUserPasswordChange",
            attrs: { mode: "user" }
          })
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }